import { render, staticRenderFns } from "./virtualScroll.vue?vue&type=template&id=8f1f2cfa&"
import script from "./virtualScroll.vue?vue&type=script&lang=js&"
export * from "./virtualScroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/layout/virtualScroll.vue"
export default component.exports